/**
 * The reporting currency (28/10/2026) — ONE currency every tracker's money is read and shown in,
 * set in Settings › Trackers (admins), US dollars by default. User: "we should have a settings
 * config somewhere that controls ALL trackers. saying we are using dollars by default".
 * Voluum and Tres Commas convert to it; Binom's report API takes no currency, so the Binom
 * account must be set to the same one. SMS texts still name the COUNTRY's currency (that is
 * what the recipient reads), and SMSWiser's route prices stay US dollars, as SMSWiser gives them.
 * For Media Devoted | Created By Ciro Autiero
 */

export const DEFAULT_REPORTING_CURRENCY = 'USD' as const;

export interface ReportingCurrencyOption {
  code: string;
  label: string;
}

export const REPORTING_CURRENCIES: readonly ReportingCurrencyOption[] = [
  { code: 'USD', label: 'US dollar ($)' },
  { code: 'EUR', label: 'Euro (€)' },
  { code: 'GBP', label: 'British pound (£)' },
  { code: 'AUD', label: 'Australian dollar (A$)' },
  { code: 'CAD', label: 'Canadian dollar (CA$)' },
  { code: 'CHF', label: 'Swiss franc (CHF)' },
  { code: 'CZK', label: 'Czech koruna (CZK)' },
  { code: 'PLN', label: 'Polish złoty (PLN)' },
];

export const isReportingCurrency = (v: unknown): v is string =>
  typeof v === 'string' && REPORTING_CURRENCIES.some((c) => c.code === v);

/** GET /admin/reporting-currency */
export interface ReportingCurrencySettings {
  currency: string;
  options: readonly ReportingCurrencyOption[];
}
